<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('courses')"/></template>
            <template v-slot:right>
                <div class="sas-head-center">
                    <v-text-field v-model="searchModel" outlined dense style="width: 300px"
                                  append-icon="mdi-magnify" placeholder="Введите название"/>
                </div>
            </template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable v-if="!isGrid" :schools="courses" :total-elements="totalElements" :totalPages="totalPages"
                        :page-size="pageSize" :current-page="currentPage" @leftClick="onLeftClick"
                        @rightClick="onRightClick">
                <template v-slot:firstItem>
                    <div class="sas-head-center-block" style="align-items: flex-start">
                        <v-select class="v-select-item" :items="classTypes" item-text="title" item-value="type"
                                  :label="$t('classes')" v-model="courseFilter.classType" outlined dense
                                  style="max-width: 276px" @change="filterCourses"/>
                    </div>
                </template>
                <template v-slot:head>
                    <th>№</th>
                    <th v-html="$t('russian')"/>
                    <th v-html="$t('kyrgyz')"/>
                    <th v-html="$t('english')"/>
                    <th v-html="$t('schools')"/>
                    <th/>
                </template>
                <template v-slot:body="{ item }">
                    <td v-html="item['pos']"/>
                    <td v-html="item['title']"/>
                    <td v-html="item['courseTitleKG']"/>
                    <td v-html="item['code']"/>
                    <td v-html="item['schoolCount']"/>
                    <td>

                    </td>
                </template>
            </SmartTable>
            <template v-else>
                <CourseMenu class="course-menu-grid" :is-grid="isGrid" @onChange="onMenuChange"></CourseMenu>
                <CourseGrid :courses="courses" @onEdit="onEdit" @onDelete="onDelete"></CourseGrid>
            </template>
            <v-dialog v-if="isAdd" id="add-form" v-model="isAdd" width="546">
                <AddCourse @close="onCloseModal" :is-edit="isEdit" :edit-course="course" :classTypes="classTypes"/>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import AddCourse from '@/components/super-admin/courses/AddCourse'
import { AdminCourseService } from '@/_services/admin-course.service'
import CourseGrid from '@/components/super-admin/courses/CourseGrid'
import CourseMenu from '@/components/super-admin/courses/CourseMenu'
import SmartSearchInput from '@/components/input/SmartSearchInput'
import PreLoader from '@/components/preloader/PreLoader'
const adminCourseService = new AdminCourseService()

export default {
    name: 'Courses',
    components: {
        SmartSearchInput,
        CourseMenu,
        CourseGrid,
        AddCourse,
        SuperAdminSchoolHead,
        SmartTable,
        PreLoader
    },
    data: () => ({
        searchModel: '',
        isLoading: false,
        required: [v => !!v || ''],
        isAdd: false,
        courses: [],
        page: 0,
        totalElements: 0,
        currentPage: 1,
        totalPages: 0,
        size: 10,
        isEdit: false,
        pageSize: 0,
        course: {},
        isDeleting: false,
        isGrid: false,
        allCourses: [],
        classTypes: [],
        courseFilter: {classType: 'ALL'}
    }),
    watch: {
        searchModel (val) {
            if (val) {
                this.courses = this.allCourses.filter(i => i.title.toLowerCase().includes(val.toLowerCase()))
            } else this.courses = this.allCourses
        }
    },
    mounted () {
        this.fetchCourses(0)
        this.classTypes = [
            { title: this.$t('primaryClasses'), type: 'JUNIOR' },
            { title: this.$t('seniorClasses'), type: 'SENIOR' },
            { title: this.$t('all'), type: 'ALL' }
        ]
    },
    created () {
        this.fetchCourses(0)
    },
    computed: {
        userProfile () {
            return this.$store.state.account.profile
        }
    },
    methods: {
        filterCourses () {
            if (this.courseFilter.classType === 'ALL') {
                this.courses = this.allCourses
            } else {
                this.courses = this.allCourses.filter((course) => course.classType === this.courseFilter.classType)
            }
        },
        onCloseModal () {
            this.isAdd = false
            this.fetchCourses()
        },
        onAdd () {
            this.isAdd = true
            this.isEdit = false
        },
        onLeftClick () {
            this.currentPage--
            this.fetchCourses(this.currentPage - 1)
        },
        onRightClick () {
            this.currentPage++
            this.fetchCourses(this.currentPage - 1)
        },
        fetchCourses (page) {
            this.isLoading = true
            adminCourseService.listWithSchoolCount('', page, this.size)
                .then((res) => {
                    this.totalElements = res.totalElements
                    this.totalPages = res.totalPages
                    this.currentPage = res.number + 1
                    this.pageSize = res.size
                    if (res.content) {
                        this.courses = res.content.map((i, index) => {
                            i.pos = index + 1
                            return i
                        })
                    } else this.courses = []
                    this.allCourses = this.courses
                    this.filterCourses()
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        onEdit (item) {
            this.course = item
            this.isAdd = true
            this.isEdit = true
        },
        onDelete (item) {
            this.course = item
            this.isDeleting = true
        },
        deleteCourse () {
            adminCourseService._delete(this.course.id)
                .then(() => {
                    this.$toast.success(this.$t('successDeleted'))
                    this.isDeleting = false
                    this.fetchCourses()
                })
                .catch(err => {
                    this.isDeleting = false
                    this.$toast.error(err)
                })
        },
        onMenuChange (val) {
            this.isGrid = val
        },
        onSearch (val) {
            if (val) {
                this.courses = this.allCourses.filter(i => i.title.toLowerCase().includes(val.toLowerCase()))
            } else this.courses = this.allCourses
        }
    }
}
</script>

<style lang="scss">
tr, th, td {
    vertical-align: middle;
}
    .c-smart-btn {
        background: linear-gradient(180deg, #4A27F3 0%, #339DFA 100%);
        border-radius: 24px;
        padding: 7px 12px;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
        font-family: Helvetica,sans-serif;
        color: #FFFFFF;
        &:active {
            border-radius: 24px;
            outline: none;
            border: 1px solid #4A27F3;
        }
    }
</style>
